// Copyright (c) 2026 Riddle, LLC. All rights reserved.
// Author: Ray Harris

import { AppRouter } from "./routes/AppRouter";

export { DEV_PREVIEW_USER_LABEL } from "./routes/AppShellLayout";

export function App() {
  return <AppRouter />;
}
